(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 67801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(1391);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63430);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12569);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80338);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67199);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_3__);








var BlogPage = function(param) {
    var preview = param.preview, subscription = param.subscription;
    var data = (0,react_datocms__WEBPACK_IMPORTED_MODULE_4__/* .useQuerySubscription */ .L)(subscription).data;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), category = ref[0], setCategory = ref[1];
    if (!data) return null;
    var posts = data.posts, categories = data.categories, _page = data.page, seo = _page.seo, title = _page.title;
    var filteredPosts = category ? posts.filter(function(post) {
        var ref;
        return ((ref = post.category) === null || ref === void 0 ? void 0 : ref.slug) === category;
    }) : posts;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Layout */ .Ar, {
        preview: preview,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .SEO */ .HJ, {
                title: "".concat(title, " | Narrative"),
                children: (0,react_datocms__WEBPACK_IMPORTED_MODULE_5__/* .renderMetaTags */ .y)(seo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Section */ .$0, {
                isFirstSection: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-h2 font-semibold leading-tight lg:text-h1",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_3__.HorizontalRule, {
                            topMargin: true,
                            bottomMargin: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .BlogCategories */ .zX, {
                                items: categories,
                                active: category,
                                handleChange: setCategory
                            })
                        }),
                        filteredPosts.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
                            children: filteredPosts.map(function(post) {
                                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_components__WEBPACK_IMPORTED_MODULE_2__/* .BlogCard */ .$h, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, post), {
                                    key: post.id
                                }));
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-center",
                            children: "There are currently no blog posts in this category."
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(67801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);